import { loadSsoStep2Sequence } from '../actions/loadSsoStep2Sequence';
import { OAuthContext } from '../types';

export const handleSsoIntegration = async (ctx: OAuthContext) => {
    const { code, backendState, uiState, dispatch, setSsoData } = ctx;

    if (uiState.type !== 'sso') return;

    return await dispatch(
        loadSsoStep2Sequence(
            {
                oauthProvider: uiState.provider,
                code,
                state: backendState,
                allowedEmail: uiState.allowedEmail,
            },
            setSsoData
        )
    );
};
